<template>
  <div class="page-content-wrapper" v-check-permission="'edit-payment-rule'">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="card m-b-20">
            <div class="card-block">
              <h4 class="mt-0 header-title">Regla para la matricula</h4>

              <template v-if="paymentRule">

                <div class="form-group  mb-3" v-bind:class="{ 'has-danger': $v.paymentRule.name.$error }">
                  <label>Nombre de la regla</label>
                  <input type="text" class="form-control col-md-6" v-model="paymentRule.name" @input="$v.paymentRule.name.$touch()">
                  <div class="form-control-feedback" v-if="!$v.paymentRule.name.required && $v.paymentRule.name.$error">El nombre es requerido.</div>
                </div>

                <div class="form-group mb-3" v-bind:class="{ 'has-danger': $v.paymentRule.career.$error }">
                  <label>Carrera</label>
                  <div class="col-md-6" style="padding-left: 0;">
                    <select id="career" class="custom-select form-control" v-model="paymentRule.career">
                      <option v-for="career in careers" v-bind:value="career._id">
                        {{ career.name }}
                      </option>
                    </select>
                  </div>
                  <div class="form-control-feedback" v-if="!$v.paymentRule.career.required && $v.paymentRule.career.$error">Seleccione una carrera.</div>
                </div>

                <div class="row">
                  <div class="form-group col-md-3 mb-3" v-bind:class="{ 'has-danger': $v.paymentRule.baseAmount.$error }">
                    <label>Monto base de la matrícula</label>
                    <input type="number" min="1" class="form-control" v-model="paymentRule.baseAmount" @input="$v.paymentRule.baseAmount.$touch()">
                    <div class="form-control-feedback" v-if="!$v.paymentRule.baseAmount.required && $v.paymentRule.baseAmount.$error">El monto base es requerido.</div>
                    <div class="form-control-feedback" v-if="!$v.paymentRule.baseAmount.minValue && $v.paymentRule.baseAmount.$error">El monto mínimo aceptado es 1.</div>
                  </div>

                  <div class="form-group col-md-3 mb-3" v-bind:class="{ 'has-danger': $v.paymentRule.expirationDay.$error }">
                    <label>Día de vencimiento de la matrícula</label>
                    <masked-input mask="1111-11-11" type="text" class="form-control" v-model="paymentRule.expirationDay" @input="$v.paymentRule.expirationDay.$touch()" />
                    <small>(YYYY-MM-DD)</small>
                    <div class="form-control-feedback" v-if="!$v.paymentRule.expirationDay.required && $v.paymentRule.expirationDay.$error">El dia de vencimiento es requerido.</div>
                  </div>
                </div>

                <div class="row">
                  <div v-if="paymentRule.discount" class="form-group col-md-3 mb-3">
                    <label>Descuento hasta el día</label>
                    <masked-input mask="1111-11-11" type="text" class="form-control" v-model="paymentRule.discount.untilDay" />
                    <small>Ingresar el dia del mes con el formato (YYYY-MM-DD), hasta el cual es valido el descuento. Una vez pasado ese dia se cobrara el monto base.</small>
                  </div>

                  <div v-if="paymentRule.discount" class="form-group col-md-3 mb-3">
                    <label>Monto del descuento</label>
                    <input type="number" min="0" class="form-control" v-model="paymentRule.discount.amount">
                    <small>Ingresar el monto que se va a descontar del monto base.</small>
                  </div>
                </div>


                <div class="form-group  m-b-0">
                  <label>Estado</label>
                  <div>
                    <label class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" v-model="paymentRule.active">
                      <span class="custom-control-indicator"></span>
                      <span class="custom-control-description">Activo</span>
                    </label>
                  </div>
                </div>


                <div class="table-responsive b-0" data-pattern="priority-columns">
                  <table class="table table-striped">
                    <thead>
                    <tr>
                      <th>Dias de retraso</th>
                      <th>Monto de interés</th>
                      <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="interest in paymentRule.interests" :key="interest._id">
                      <td>{{ interest.daysOfDelay }}</td>
                      <td>${{ interest.amount }}</td>
                      <td class="pull-right">
                        <a href="javascript:void(0);" class="text-primary" @click="deleteInterest(interest._id)"><i class="fa fa-minus-circle"></i></a>
                      </td>
                    </tr>
                    <tr v-if="paymentRule.interests && paymentRule.interests.length === 0">
                      <td colspan="4">Aun no se ha cargado intereses.</td>
                    </tr>
                    </tbody>
                  </table>

                  <table class="table table-striped">
                    <thead>
                    <tr>
                      <th>Cantidad de recargos: <b v-if="paymentRule.interests">{{ paymentRule.interests.length }}</b><b v-else>0</b></th>
                      <th>Monto total de intereses: <b>${{ totalAmountOfInterest }}</b></th>
                      <th></th>
                    </tr>
                    </thead>
                  </table>
                </div>

                <div class="col-md-6">
                  <small>Los dias de interes se cuentan desde la fecha de vencimiento de la cuota.</small>
                  <h4 class="mt-0 header-title">Agregar intereses</h4>

                  <div class="row">
                    <div class="form-group col-md-6 mb-3" v-bind:class="{ 'has-danger': $v.interest.daysOfDelay.$error }">
                      <label>Dias de retraso</label>
                      <input type="number" min="1" ref='daysOfDelay'  @keyup.enter="addInterest()" class="form-control" v-model="interest.daysOfDelay">
                      <small>Ingresar la cantidad de dias de retraso.</small>
                      <div class="form-control-feedback" v-if="!$v.interest.daysOfDelay.required && $v.interest.daysOfDelay.$error">La cantidad de días es requerida.</div>
                    </div>

                    <div class="form-group col-md-6 mb-3" v-bind:class="{ 'has-danger': $v.interest.amount.$error }">
                      <label>Monto de interés</label>
                      <input type="number" min="0" @keyup.enter="addInterest()" class="form-control" v-model="interest.amount">
                      <small>Ingresar el monto que se va a aumentar al monto base.</small>
                      <div class="form-control-feedback" v-if="!$v.interest.amount.required && $v.interest.amount.$error">El monto es requerido.</div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <button class="btn btn-info pull-right" @click="addInterest()">Agregar</button>
                    </div>
                  </div>

                </div>


                <div class="card-block pull-right pr-0">
                  <router-link to="/payment-rules-for-tuition" class="btn btn-secondary waves-effect m-r-10">Cancelar</router-link>
                  <a href="javascript:void(0);" class="btn btn-primary waves-effect waves-light save-btn" @click="submit()">Guardar</a>
                </div>

              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { required, between, minValue } from 'vuelidate/lib/validators'
  import MaskedInput from 'vue-masked-input'

  export default {
    name: 'edit-payment-rule-for-tuition',



    components: {
      MaskedInput
    },



    created () {
      this.getAllCareers();
      this.getPaymentRuleForTuition();
    },




    data () {
      return {
        interest: {
          _id: null,
          daysOfDelay: null,
          amount: null
        }
      }
    },




    computed: {
      paymentRule: function () {
        return this.$store.getters.getPaymentRule
      },

      careers: function () {
        return this.$store.getters.getAllCareers
      },

      totalAmountOfInterest: function() {
        if(this.paymentRule.interests) {
          return this.paymentRule.interests.map((item) => item.amount).reduce(function (total, amount) {
            return Number(total) + Number(amount)
          }, 0);
        } else {
          return 0;
        }
      }
    },




    validations: {
      paymentRule: {
        name: {
          required
        },
        career: {
          required
        },
        baseAmount: {
          required,
          minValue: minValue(1)
        },
        expirationDay: {
          required,
        }
      },
      interest: {
        daysOfDelay: {
          required
        },
        amount: {
          required
        }
      }
    },




    methods: {

      getPaymentRuleForTuition: function () {
        this.$loader.loading();
        var self = this;

        this.$store.dispatch('getPaymentRuleForTuition', { id : this.$route.params.id })
          .then((response) => {

            if(response.data && response.data.expirationDay) {
              self.paymentRule.expirationDay = response.data.expirationDay.split('T')[0];
            }
            if(response.data && response.data.discount && response.data.discount.untilDay) {
              self.paymentRule.discount.untilDay = response.data.discount.untilDay.split('T')[0];
            }

            this.$loader.close();
          })
          .catch(error => {
            this.$message.error({text: error})
          })
      },



      getAllCareers () {
        this.$loader.loading();

        this.$store.dispatch('getAllCareers')
          .then((response) => {
            this.$loader.close();
          })
          .catch((response) => {
            this.$loader.close();
          })
      },



      addInterest() {
        if( this.validateInterest() ) {
          var newInterest = {
            _id: this.$uid.generateUID(),
            daysOfDelay: this.interest.daysOfDelay,
            amount: this.interest.amount
          };

          this.paymentRule.interests.push(newInterest);

          this.sortInterest();
          this.clearInterest();

          this.$refs.daysOfDelay.focus();
        }
      },



      validateInterest() {

        this.$v.interest.daysOfDelay.$touch();
        this.$v.interest.amount.$touch();

        if( !this.$v.interest.daysOfDelay.$error &&
          !this.$v.interest.amount.$error ) {

          return true

        }

        return false;
      },



      deleteInterest(id) {
        this.paymentRule.interests = this.paymentRule.interests.filter(function (item) {
          return id != item._id;
        })
      },



      clearInterest() {
        this.interest.daysOfDelay = null;
        this.interest.amount = null;
      },



      sortInterest() {
        this.paymentRule.interests.sort(function (a, b) {
          const daysOfDelayA = Number(a.daysOfDelay);
          const daysOfDelayB = Number(b.daysOfDelay);

          let comparison = 0;
          if (daysOfDelayA > daysOfDelayB) {
            comparison = 1;
          } else if (daysOfDelayA < daysOfDelayB) {
            comparison = -1;
          }
          return comparison;
        })
      },



      submit: function () {
        const self = this
        this.$v.paymentRule.$touch()

        if(!this.$v.paymentRule.$error) {
          $('.save-btn').attr('disabled', true);

          this.$store.dispatch('editPaymentRuleForTuition', {rule: this.paymentRule})
            .then((response) => {

              if(response.success) {
                self.$message.success();

                setTimeout(function () {
                  self.$router.push('/payment-rules-for-tuition')
                }, 500)
              } else {
                self.$message.error({text: response.message});
              }

              $('.save-btn').attr('disabled', false)
            })
            .catch((response) => {
              self.$message.error({text: response.message});
              $('.save-btn').attr('disabled', false)
            })
        }
      }

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/screens/EditPaymentRuleForTuitionScreen.vue